<div class="tw-flex tw-h-full tw-flex-col">
  <ng-container *ngIf="isMobileFirstSetup">
    <div class="tw-p-6">
      <div class="tw-text-center">
        <div class="tw-my-8">
          <span class="tw-text-lg"> {{ "biometricVerificationDesc" | i18n }}</span>
        </div>

        <div class="tw-mb-10 tw-flex tw-justify-center tw-gap-6">
          <icon [name]="'face-id'" [size]="16"></icon>
          <icon [name]="'fingerprint'" [size]="16"></icon>
        </div>
      </div>
      <div class="tw-flex tw-flex-col tw-gap-4 hover:tw-cursor-pointer">
        <app-gloss-button [options]="enableBiometricsOptions"> </app-gloss-button>
        <app-gloss-button [options]="cancelButtonOptions"> </app-gloss-button>
      </div>
    </div>
  </ng-container>
  <div *ngIf="!isMobileFirstSetup">
    <div class="tw-w-full tw-rounded-lg tw-bg-dt-surface-elevated tw-p-6">
      <span class="tw-text-xl tw-font-medium">{{ "thisDevice" | i18n }}</span>
      <ng-container *ngTemplateOutlet="deviceInfo"></ng-container>
      <div
        class="tw-flex tw-justify-between tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-t tw-border-dt-border-primary tw-py-4"
      >
        <div class="tw-flex tw-items-center tw-gap-2">
          <icon [name]="biometricIcon" [size]="5"></icon>
          <span class="tw-text-sm">{{ "enableBiometricVerification" | i18n }}</span>
        </div>
        <!-- toggle-switch's [disabled] is what blocks enabling on Desktop (click and keyboard) -->
        <div
          [class.tw-opacity-50]="biometricEnableRestricted"
          [title]="biometricEnableRestricted ? ('biometricEnableDesktopUnsupported' | i18n) : null"
        >
          <toggle-switch
            #biometricSwitch
            (onClick)="onBiometricToggle($event, biometricSwitch)"
            [isEnabled]="enableToggle"
            [disabled]="biometricEnableRestricted"
            [ariaLabel]="'enableBiometricVerification' | i18n"
          ></toggle-switch>
        </div>
      </div>
    </div>
    <div *ngIf="!isMobileDevice && otherDevices.length > 0" class="tw-mt-6">
      <span class="tw-text-xl tw-font-medium">{{ "otherDevices" | i18n }}</span>
      <div
        *ngFor="let device of otherDevices"
        class="tw-mt-2 tw-w-full tw-rounded-lg tw-bg-dt-surface-elevated tw-p-6"
      >
        <div class="tw-flex tw-flex-col tw-py-4">
          <span class="tw-text-lg tw-capitalize">{{
            device.deviceType || ("unknown" | i18n)
          }}</span>
        </div>
        <div
          class="tw-flex tw-justify-between tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-t tw-border-dt-border-primary tw-py-4"
        >
          <div class="tw-flex tw-items-center tw-gap-2">
            <icon [name]="'fingerprint'" [size]="5"></icon>
            <span class="tw-text-sm">{{ "biometricVerification" | i18n }}</span>
          </div>
          <div [class.tw-opacity-50]="!device.biometricEnabled">
            <toggle-switch
              #deviceSwitch
              (onClick)="onOtherDeviceBiometricToggle(device, $event, deviceSwitch)"
              [isEnabled]="device.biometricEnabled"
              [disabled]="!device.biometricEnabled"
              [ariaLabel]="
                (device.deviceType || ('unknown' | i18n)) + ' - ' + ('biometricVerification' | i18n)
              "
            ></toggle-switch>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #deviceInfo>
    <div class="tw-flex tw-gap-4">
      <!--      <div class="tw-w-8">Icon</div>-->
      <div class="tw-flex tw-flex-col tw-py-4">
        <!--        <span class="tw-text-xl">Current session</span>-->
        <span class="tw-text-lg" [class.tw-capitalize]="deviceType !== 'ios'">{{
          deviceType === "ios" ? "iOS" : deviceType
        }}</span>
      </div>
    </div>
  </ng-template>
  <ng-template #webAuthnTemplate></ng-template>
</div>
